<template lang="pug">
div
  h2.text-center {{confirmationTitle}}
  p &nbsp;
  p {{confirmationMessage}}
  p(v-if="rowId !== 'new'") If you would like to edit your response please&nbsp;
    a(:href="url") click here&nbsp;
    | or copy the edit link below:
  p
    input.form-control(ref="copyinput" @click.native="copy" @focus="copy" :value="url" readonly)
  transition(name="copy-alert")
    div.copy-alert.alert.alert-success(v-if="copied") Link copied to clipboard
  p &nbsp;
  p &nbsp;
</template>

<script>
export default {
  name: "Complete",
  data() {
    return {
      copied: false,
      url: null
    };
  },
  computed: {
    confirmationMessage() {
      return this.$root.confirmationMessage || "Thank you for your response.";
    },
    confirmationTitle() {
      return this.$root.confirmationTitle || "Form submission complete!";
    },
    rowId() {
      return this.$route.params.rowId;
    }
  },
  mounted() {
    const url = window.location.href.replace(/^(.+)#.*$/, "$1");
    const { formId, rowId } = this.$route.params;
    this.url = `${url}#/${formId}/${rowId}`;
  },
  methods: {
    copy() {
      const el = this.$refs.copyinput;
      el.value = this.url;
      el.select();
      document.execCommand("copy");
      this.copied = true;
      setTimeout(() => (this.copied = false), 5000);
    }
  }
};
</script>
<style scoped>
.copy-alert {
  transition: all 0.5s;
  opacity: 1;
}
.copy-alert-enter-active {
  opacity: 0;
}
.copy-alert-leave-active {
  opacity: 0;
}
</style>
